<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #fff;background: #f7f7f7;border-radius: 5px;">
				<!-- <div class="base_inquire" style="padding: 20px 30px 5px;border-bottom: 1px solid #ccc;">
					<div class="b_item">
						<span class="b_label">区域：</span>
						<VDistpicker @province="handleSearchProvinceSelect" @city="handleSearchCitySelect"
							@area="handleSearchAreaSelect"></VDistpicker>
					</div>
					<div class="b_item">
						<span class="b_label">产品：</span>
						<el-select v-model="search_product" class="b_inp" placeholder="请选择" :clearable="true">
							<el-option v-for="v in authProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
						</el-select>
					</div>
					<div class="b_item">
						<span class="b_label">开始时间：</span>
						<el-date-picker v-model="search_startTime" :editable="false" placeholder="开始时间" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchStartTimeClick">
						</el-date-picker>
					</div>

					<div class="b_item">
						<span class="b_label">结束时间：</span>
						<el-date-picker v-model="search_endTime" :editable="false" placeholder="结束时间" type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearchEndTimeClick">
						</el-date-picker>
					</div>
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div> -->

				<!-- <div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<span class="b_label">代理商名称：</span>
						<el-autocomplete class="b_inp" v-model="search_name" :fetch-suggestions="querySearchName"
							placeholder="请输入代理商名称"></el-autocomplete>
					</div>
					<div v-if="search_type == 1" class="b_item">
						<span class="b_label">支付类型：</span>
						<el-select v-model="search_payType" class="b_inp" placeholder="请选择" :clearable="true">
							<el-option v-for="v in payType" :key="v.type" :value="v.type" :label="v.name"></el-option>
						</el-select>
					</div>
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div> -->

			</div>
			<!-- 顶部查询 end -->

			<!-- 总计 -->
			<!-- <div class="clear_both" style="margin-top: 20px;">
				<div style="float: left;color: #222;line-height: 36px;">总计：已收入<span
						style="margin: 0 5px;font-size: 28px;color: #409EFF;">{{ total }}</span>笔。</div>
				<div style="float: right;">
					<el-button type="primary" @click="exportExcel">下载：excel格式</el-button>
				</div>
			</div> -->
			<!-- 总计 end -->

			<!-- 查询类型 -->
			<!-- <div class="base_inquire" style="margin-top: 20px;">
				<div class="b_item">
					<span class="b_label">查询类型：</span>
					<el-select v-model="search_type" class="b_inp" @change="handleSearchTypeChange">
						<el-option value="1" label="充值"></el-option>
						<el-option value="2" label="消费"></el-option>
					</el-select>
				</div>
			</div> -->
			<!-- 查询类型 end -->

			<!-- 状态 -->
			<!-- <ul class="base_table_status">
				<li v-for="v in show_type" :key="v.category" :class="{b_item_on: show_type_active == v.category}" class="b_item"
					@click="handleShowTypeClick(v.category)">{{ v.name }}</li>
			</ul> -->
			<!-- 状态 end -->

			<!-- 表格 -->
			<!-- <div class="base_table">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="code" :label="search_type == 1 ? '编码' : '账号'">
					</el-table-column>
					<el-table-column prop="name" :label="search_type == 1 ? '代理商名称' : '被操作人'">
					</el-table-column>
					<el-table-column prop="num" label="次数">
					</el-table-column>
					<el-table-column prop="productName" label="产品">
					</el-table-column>
					<el-table-column v-if="search_type == 1 && authInfo.ucategory == 1" prop="counts" label="购买次数">
					</el-table-column>
					<el-table-column v-if="search_type == 1" prop="payName" label="支付类型">
					</el-table-column>
					<el-table-column prop="actionName" label="操作类型">
					</el-table-column>
					<el-table-column prop="operator" label="操作人">
					</el-table-column>
					<el-table-column prop="operatorForm" label="操作机构">
					</el-table-column>
					<el-table-column v-if="search_type == 1" prop="remark" label="备注">
					</el-table-column>
					<el-table-column prop="creatTime" label="创建时间">
					</el-table-column>
				</el-table>
			</div> -->
			<!-- 表格 end -->

			<!-- 页码 -->
			<!-- <div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div> -->
			<!-- 页码 end -->

			<!-- 折线图 -->
			<!-- 			<div v-if="missionId && trainingChartData.length" ref="training_chart"
				style="height: 350px;margin-top: 20px;border: 1px solid #ccc;border-radius: 10px;"></div> -->
			<div v-if="showdata" id="echartLine1" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>
			<div v-if="showdata" id="echartLine" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>

			<div v-if="showdata" id="echartLine4" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>
			<div v-if="showdata" id="echartLine5" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>



			<div v-if="showdata" id="echartLine3" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>

			<div v-if="showdata" id="echartLine2" class="echartDiv" style="width: 100%;height: 500px;margin-top: 100px;">
			</div>


			<!-- 折线图 end -->
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import Api from '../../../../api/index.js'
	import {
		mapState
	} from 'vuex'
	import BaseMethods from "../../../../assets/js/base.js"

	export default {
		mounted() {
			this.setShowType();
			this.getList();
			this.userConsumption(); //报表查询
			this.findagentConsumptionData(); //代理商报表查询

		},
		beforeDestroy() {
			this.queryInterval && clearTimeout(this.queryInterval);
		},
		data() {
			return {
				yue: [{
						month: 1,
						sum: 0
					},
					{
						month: 2,
						sum: 0
					},
					{
						month: 3,
						sum: 0
					},
					{
						month: 4,
						sum: 0
					},
					{
						month: 5,
						sum: 0
					},
					{
						month: 6,
						sum: 0
					},
					{
						month: 7,
						sum: 0
					},
					{
						month: 8,
						sum: 0
					},
					{
						month: 9,
						sum: 0
					},
					{
						month: 10,
						sum: 0
					},
					{
						month: 11,
						sum: 0
					},
					{
						month: 12,
						sum: 0
					}
				],
				agentyear: [],
				agentyearSum: [],
				agentseries: [],
				hosyear: [],
				hosyearSum: [],
				hosseries: [],
				year: [],
				yearSum: [],
				showdata: true,
				series: [],
				missionId: null,
				trainingChartData: [],
				payType: [{
					type: '1',
					name: '企业支付'
				}, {
					type: '2',
					name: '支付宝'
				}, {
					type: '3',
					name: '转账'
				}, {
					type: '8',
					name: '商城充值卡'
				}, {
					type: '9',
					name: '商城训练卡'
				}, {
					type: '10',
					name: '科飞商城购买虚拟充值'
				}],
				allType: {
					'1': [{
						category: '0',
						name: '全部'
					}, {
						category: '1',
						name: '充值'
					}, {
						category: '2',
						name: '赠送'
					}, {
						category: '3',
						name: '扣除返还'
					}],
					'2': [{
						category: '0',
						name: '全部'
					}, {
						category: '1',
						name: '正常消费划拨'
					}, {
						category: '2',
						name: '赠送'
					}, {
						category: '3',
						name: '被扣除'
					}]
				},

				loading: false,

				search_addr: {
					provinceCode: '',
					provinceName: '',
					cityCode: '',
					cityName: '',
					areaCode: '',
					areaName: ''
				},
				search_product: '',
				search_startTime: '',
				search_endTime: '',
				search_name: '',
				search_payType: '',
				search_type: '1',

				show_type: [],
				show_type_active: '0',

				currentPage: 1,
				total: 0,
				tableData: [],
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'authProduct'
			])
		},
		methods: {
			/******************** @Ajax *************************/


			userConsumption() {
				const that = this;
				that.loading = true;
				Api.finduserConsumptionData().then((res) => {
					that.loading = false;
					if (res.data.success) {
						let rgbtip = ['#FFD26F', '#52E5E7', '#ABDCFF', '#79F1A4', '#FCCF31', '#F97794', '#FEC163', '#F1CA74',
							'#E8D07A',
							'#FEB692',
							'#CE9FFC',
							'#F97794', '#5EFCE8', '#92FFC0',
						];
						let rgbbot = ['#3677FF', '#130CB7', '#0396FF', '#0E5CAD', '#F55555', '#623AA2', '#FEC163', '#A64DB6',
							'#5312D6',
							'#EA5455',
							'#7367F0',
							'#623AA2', '#736EFE', '#002661',
						];
						let a = [];
						let b = [];
						let list = res.data.data
						list.forEach((item, index) => {
							that.year.push(item.year + '年')
							that.yearSum.push(item.yearSum)
							let monthlist = item.monthSum //月份
							monthlist.forEach((item1) => {
								b.push(item1.sum)
							})
							a.push({
								name: item.year.toString(), //年份
								type: 'bar',
								data: b,
								itemStyle: {
									color: {
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										type: "linear",
										global: false,
										colorStops: [{
												offset: 0,
												color: rgbtip[index],
											},
											{
												offset: 1,
												color: rgbbot[index],
											},
										],
									},
								},

							})
							b = [];
						})

						that.series = a
						that.echartInit(); //执行月度图表
						that.echartInit1(); //年度
						that.hosuserConsumption();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},

			//代理商
			findagentConsumptionData() {
				const that = this;
				that.loading = true;
				Api.findagentConsumptionData().then((res) => {
					that.loading = false;
					if (res.data.success) {

						console.log(res)

						let rgbtip = ['#FFD26F', '#52E5E7', '#ABDCFF', '#79F1A4', '#FCCF31', '#F97794', '#FEC163', '#F1CA74',
							'#E8D07A',
							'#FEB692',
							'#CE9FFC',
							'#F97794', '#5EFCE8', '#92FFC0',
						];
						let rgbbot = ['#3677FF', '#130CB7', '#0396FF', '#0E5CAD', '#F55555', '#623AA2', '#FEC163', '#A64DB6',
							'#5312D6',
							'#EA5455',
							'#7367F0',
							'#623AA2', '#736EFE', '#002661',
						];
						let a = [];
						let b = [];
						let list = res.data.data
						list.forEach((item, index) => {
							that.agentyear.push(item.year + '年')
							that.agentyearSum.push(item.yearSum)
							let monthlist = item.monthSum //月份



							monthlist.forEach((item1) => {
								b.push(item1.sum)
							})

							a.push({
								name: item.year.toString(), //年份
								type: 'bar',
								data: b,
								itemStyle: {
									color: {
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										type: "linear",
										global: false,
										colorStops: [{
												offset: 0,
												color: rgbtip[index],
											},
											{
												offset: 1,
												color: rgbbot[index],
											},
										],
									},
								},

							})
							b = [];
						})

						that.agentseries = a
						that.echartInit4(); //年度
						that.echartInit5(); //执行月度图表


					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},



			hosuserConsumption() {
				const that = this;
				that.loading = true;
				Api.finduserhosConsumptionData().then((res) => {
					that.loading = false;
					if (res.data.success) {

						let rgbtip = ['#92FFC0', '#5EFCE8', '#F97794', '#CE9FFC', '#FEB692', '#E8D07A', '#F1CA74', '#FEC163',
							'#F97794', '#FCCF31', '#79F1A4', '#ABDCFF', '#52E5E7', '#FFD26F',
						];


						let rgbbot = ['#002661', '#736EFE', '#623AA2', '#7367F0', '#EA5455', '#5312D6', '#A64DB6', '#FEC163',
							'#623AA2', '#F55555', '#0E5CAD', '#0396FF', '#130CB7', '#3677FF'
						];

						let a = [];
						let b = [];
						let list = res.data.data
						list.forEach((item, index) => {
							that.hosyear.push(item.year + '年')
							that.hosyearSum.push(item.yearSum)
							let monthlist = item.monthSum //月份
							monthlist.forEach((item1) => {
								b.push(item1.sum)
							})
							a.push({
								name: item.year.toString(), //年份
								type: 'bar',
								data: b,
								itemStyle: {
									color: {
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										type: "linear",
										global: false,
										colorStops: [{
												offset: 0,
												color: rgbtip[index],
											},
											{
												offset: 1,
												color: rgbbot[index],
											},
										],
									},
								},

							})
							b = [];
						})

						that.hosseries = a
						that.echartInit2(); //年度
						that.echartInit3(); //月度
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},







			// 获取列表数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					"endTime": that.search_endTime,
					"id": null,
					"limit": 10,
					"loginCategory": that.authInfo.ucategory,
					"loginEnterpriseId": that.authInfo.uenterpriseId,
					"loginUserId": that.authInfo.uid,
					"oneCategory": that.search_type,
					"pageNum": that.currentPage,
					"queryType": 2,
					"startTime": that.search_startTime,
					"twoCategory": that.show_type_active,
					"uareaName": that.search_addr.areaName,
					"uareaCode": that.search_addr.areaCode,
					"ucityName": that.search_addr.cityName,
					"ucityCode": that.search_addr.cityCode,
					"ucode": that.authInfo.ucode,
					"uenterpriseId": null,
					"uprovinceName": that.search_addr.provinceName,
					"uprovinceCode": that.search_addr.provinceCode,
					"uqueryEnterpriseName": that.search_name,
					"versionFlag": that.search_product,
					"payType": that.search_payType,
					"functionType": 1
				};
				Api.findFinanceCountConsumeRecord(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							data.push({
								code: that.search_type == 1 ?
									v.code : that.search_type == 2 ?
									v.operatorCode : '',
								name: that.search_type == 1 ?
									v.enterpriseName : that.search_type == 2 ?
									v.operator : '',
								num: v.utime || '',
								productId: v.uversionFlag || '',
								productName: '',
								payType: v.payType || '',
								payName: that.mapPayTypetoName(v.payType),
								actionCategory: v.ucategory || '',
								actionName: that.getActionNameByCategory(v.ucategory),
								operator: v.username || '/',
								operatorForm: v.usernameEnterpriseName || '/',
								remark: v.memo || '/',
								counts: v.counts || 0,
								creatTime: v.ucreateTs || ''
							});
						});
						that.tableData = data;
						that.mapProductIdtoName();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/******************** @Events *************************/


			//科飞年度报表
			echartInit1() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine1'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '终端用户消耗年报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: this.year,
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						nameGap: 50, //坐标轴名称与轴线之间的距离
						nameRotate: 90, //坐标轴名字旋转角度值,
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					series: [{
						data: this.yearSum,
						type: 'bar', // 折线图line 或柱状图bar
						smooth: false, //折线图 true 为曲线 false是直线
						name: '次数',
						barMaxWidth: "auto",
						barWidth: 20, // 设置每个柱子的宽度为40
						lineStyle: {
							color: '#FFC058',
							width: 2,
							// shadowColor: 'rgba(0, 0, 0, 1)', //设置折线阴影
							shadowColor: '#FFC058', //设置折线阴影
							shadowBlur: 15,
							shadowOffsetY: 20,
						},
						itemStyle: {
							color: {
								x: 0,
								y: 0,
								x2: 10,
								y2: 1,
								type: "linear",
								global: false,
								colorStops: [{
										offset: 0,
										color: "#FF932F",
									},
									{
										offset: 1,
										color: "#FFC058",
									},
								],
							},
						},

						label: {
							show: true, //开启显示
							position: 'top', //在上方显示
						}
					}]

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},



			echartInit() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '终端用户消耗月报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					legend: {
						data: this.series,
						top: "0%" // 设置图例位置在顶部
					},
					series: this.series,

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},




			//科飞年度报表
			echartInit2() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine2'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '机构用户消耗月报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					legend: {
						data: this.hosseries,
						top: "0%" // 设置图例位置在顶部
					},
					series: this.hosseries,

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},



			//科飞年度报表
			echartInit3() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine3'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '机构用户消耗年报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: this.hosyear,
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						nameGap: 50, //坐标轴名称与轴线之间的距离
						nameRotate: 90, //坐标轴名字旋转角度值,
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					series: [{
						data: this.hosyearSum,
						type: 'bar', // 折线图line 或柱状图bar
						smooth: false, //折线图 true 为曲线 false是直线
						name: '次数',
						barMaxWidth: "auto",
						barWidth: 20, // 设置每个柱子的宽度为40
						lineStyle: {
							color: '#FFC058',
							width: 2,
							// shadowColor: 'rgba(0, 0, 0, 1)', //设置折线阴影
							shadowColor: '#FFC058', //设置折线阴影
							shadowBlur: 15,
							shadowOffsetY: 20,
						},
						itemStyle: {
							color: {
								x: 0,
								y: 0,
								x2: 10,
								y2: 1,
								type: "linear",
								global: false,
								colorStops: [{
										offset: 0,
										color: "#FF932F",
									},
									{
										offset: 1,
										color: "#FFC058",
									},
								],
							},
						},

						label: {
							show: true, //开启显示
							position: 'top', //在上方显示
						}
					}]

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},

			//科飞年度报表
			echartInit5() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine5'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '代理商用户消耗月报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					legend: {
						data: this.agentseries,
						top: "0%" // 设置图例位置在顶部
					},
					series: this.agentseries,

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},


			//科飞年度报表
			echartInit4() {
				// let that = this;
				// echarts.dispose(document.getElementById('echartLine')) //先清空图表
				var myChart = echarts.init(document.getElementById('echartLine4'));
				// 指定图表的配置项和数据
				let option = {
					title: {
						text: '代理商用户消耗年报表',
						subtext: ''
					},
					// color: ['#3398DB'],
					dataZoom: [{
							type: 'inside',
							start: 0,
							end: 100,
						},

						{
							show: false,
							type: 'slider',
							y: '90%',
							start: 0,
							end: 100,
						}
					],

					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					toolbox: {
						show: true,

						feature: {
							dataView: {
								show: true,
								readOnly: true,

							},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '10%',
						right: '10%',
						left: '5%',
						bottom: '12%',
						containLabel: true
					},
					// legend: {
					// 	data: ['数据1', '数据2'],
					// 	itemStyle: {
					// 		color: '#333',
					// 		borderColor: '#999',
					// 		borderWidth: 1,
					// 		borderRadius: 5
					// 	}
					// },
					xAxis: [{
						type: 'category',
						color: '#59588D',
						// that.wang
						data: this.agentyear,
						axisLabel: {
							margin: 20,
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false,
						},
					}],
					yAxis: [{
						nameGap: 50, //坐标轴名称与轴线之间的距离
						nameRotate: 90, //坐标轴名字旋转角度值,
						axisLabel: {
							color: '#999',
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(107,107,107,0.37)',
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(131,101,101,0.2)',
								type: 'dashed',
							}
						}
					}],

					series: [{
						data: this.agentyearSum,
						type: 'bar', // 折线图line 或柱状图bar
						smooth: false, //折线图 true 为曲线 false是直线
						name: '次数',
						barMaxWidth: "auto",
						barWidth: 20, // 设置每个柱子的宽度为40
						lineStyle: {
							color: '#FFC058',
							width: 2,
							// shadowColor: 'rgba(0, 0, 0, 1)', //设置折线阴影
							shadowColor: '#FFC058', //设置折线阴影
							shadowBlur: 15,
							shadowOffsetY: 20,
						},
						itemStyle: {
							color: {
								x: 0,
								y: 0,
								x2: 10,
								y2: 1,
								type: "linear",
								global: false,
								colorStops: [{
										offset: 0,
										color: "#FF932F",
									},
									{
										offset: 1,
										color: "#FFC058",
									},
								],
							},
						},

						label: {
							show: true, //开启显示
							position: 'top', //在上方显示
						}
					}]

				};

				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			},




			// 切换查询区域省份
			handleSearchProvinceSelect(data) {
				this.search_addr.provinceName = data.code ? data.value : '';
				this.search_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 切换查询区域城市
			handleSearchCitySelect(data) {
				this.search_addr.cityName = data.code ? data.value : '';
				this.search_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询区域区域
			handleSearchAreaSelect(data) {
				this.search_addr.areaName = data.code ? data.value : '';
				this.search_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询时间
			handleSearchStartTimeClick() {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick() {
				this.compareSearchTime();
			},
			// 切换查询类型
			handleSearchTypeChange() {
				this.setShowType();
				this.resetData();
				this.getList();
			},
			// 所属代理商匹配
			querySearchName(queryString, cb) {
				const that = this;
				that.queryInterval && clearTimeout(that.queryInterval);
				that.queryInterval = setTimeout(() => {
					var results = [];
					var requestData = {
						EnterpriseName: queryString
					};
					Api.findFirmsByName(requestData).then((res) => {
						if (res.data.success) {
							res.data.data.forEach(v => {
								results.push({
									value: v
								});
							});
							cb(results);
						} else {
							cb([]);
						}
					}, () => {
						cb([]);
					});
				}, 300);
			},
			// 点击查询
			handleSearchClick() {
				this.resetData();
				this.getList();
			},
			// 导出Excel数据
			exportExcel() {
				const that = this;
				that.loading = true;
				var requestData = {
					"endTime": that.search_endTime,
					"id": null,
					"limit": 10000,
					"loginCategory": that.authInfo.ucategory,
					"loginEnterpriseId": that.authInfo.uenterpriseId,
					"loginUserId": that.authInfo.uid,
					"oneCategory": that.search_type,
					"pageNum": 1,
					"queryType": 2,
					"startTime": that.search_startTime,
					"twoCategory": that.show_type_active,
					"uareaName": that.search_addr.areaName,
					"uareaCode": that.search_addr.areaCode,
					"ucityName": that.search_addr.cityName,
					"ucityCode": that.search_addr.cityCode,
					"ucode": that.authInfo.ucode,
					"uenterpriseId": null,
					"uprovinceName": that.search_addr.provinceName,
					"uprovinceCode": that.search_addr.provinceCode,
					"uqueryEnterpriseName": that.search_name,
					"versionFlag": that.search_product,
					"payType": that.search_payType,
					"functionType": 2
				};
				Api.findFinanceCountConsumeRecord(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str =
							`序号,${ that.search_type == 1 ? '编码' : '账号' },${ that.search_type == 1 ? '代理商名称' : '被操作人' },次数,产品,${ that.search_type == 1 && that.authInfo.ucategory == 1 ? '购买次数,' : '' }${ that.search_type == 1 ? '支付类型,' : '' }操作类型,操作人,操作机构,${ that.search_type == 1 ? '备注,' : '' }创建时间,\n`;
						res.data.data.data.forEach((v, index) => {
							str += `${ index+1 },`
							str += v.code || '';
							str += '\t,';
							str += that.search_type == 1 ?
								v.enterpriseName :
								that.search_type == 2 ?
								v.operator :
								'';
							str += ',';
							str += v.utime || '';
							str += ',';
							for (var i = 0; i < that.authProduct.length; i++) {
								if (v.uversionFlag == that.authProduct[i].id)
									str += that.authProduct[i].name;
							}
							str += ',';
							(that.search_type == 1 && that.authInfo.ucategory == 1) && (str += v.counts);
							(that.search_type == 1 && that.authInfo.ucategory == 1) && (str += ',');
							that.search_type == 1 && (str += that.mapPayTypetoName(v.payType));
							that.search_type == 1 && (str += ',');
							str += that.getActionNameByCategory(v.ucategory);
							str += ',';
							str += v.username || '/';
							str += ',';
							str += v.usernameEnterpriseName || '/';
							str += ',';
							that.search_type == 1 && (str += v.memo || '/');
							that.search_type == 1 && (str += ',');
							str += v.ucreateTs || '';
							str += '\t,';
							str += '\n';
						});
						BaseMethods.outputExcel(str, '代理商对账');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击显示类型
			handleShowTypeClick(category) {
				if (this.show_type_active != category) {
					this.show_type_active = category;
					this.resetData();
					this.getList();
				}
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			/******************** @Function *************************/
			// 设置显示类型
			setShowType() {
				this.show_type = this.allType[this.search_type];
				this.show_type_active = this.show_type[0].category;
			},
			// 重置需要重置的数据
			resetData() {
				this.search_type == 2 && (this.search_payType = '');
				this.currentPage = 1;
			},
			// 根据操作类型转换操作名称
			getActionNameByCategory(category) {
				var list = this.allType[this.search_type],
					result = '';
				for (var i = 0; i < list.length; i++) {
					if (list[i].category == category)
						result = list[i].name;
				}
				return result;
			},
			// 比较开始时间和结束时间
			compareSearchTime() {
				if (this.search_startTime && this.search_endTime) {
					var startTime = new Date(this.search_startTime).getTime(),
						endTime = new Date(this.search_endTime).getTime();
					if (endTime < startTime) {
						this.search_endTime = '';
						this.$message({
							message: '结束时间不能小于开始时间',
							type: 'warning'
						});
					}
				}
			},
			// 获取支付类型名称
			mapPayTypetoName(type) {
				var str = '';
				this.payType.forEach(v => {
					v.type == type && (str = v.name);
				});
				return str;
			},
			// 把产品id转为名称
			mapProductIdtoName() {
				var arr = [...this.tableData];
				if (this.authProduct.length) {
					arr.forEach((v) => {
						for (var i = 0; i < this.authProduct.length; i++) {
							if (v.productId == this.authProduct[i].id)
								v.productName = this.authProduct[i].name;
						}
					});
				}
				this.tableData = arr;
			}
		}
	}
</script>

<style scoped>
</style>